import * as React from "react"
import PublicAppBar from "../../../components/appbar/PublicAppBar"
import { Container, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"

const SystemMaintenance: React.FC<any> = () => {
  const { t } = useTranslation()

  return (
    <Container maxWidth="lg">
      <PublicAppBar />
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <Typography
          sx={{ fontWeight: "bold", fontSize: "36px", marginBottom: 2 }}
        >
          307
        </Typography>
        <Typography
          sx={{ fontWeight: "bold", fontSize: "32px", marginBottom: 2 }}
        >
          {t("text_title_system_maintenance")}
        </Typography>
        <Typography
          sx={{ fontWeight: "bold", fontSize: "28px", marginBottom: 2 }}
        >
          {t("text_detail_system_maintenance")}
        </Typography>
      </div>
    </Container>
  )
}

export default SystemMaintenance
